import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2),
        paddingLeft: theme.spacing(0.5),
      '& .numbered:not(.levelUp):not(.topLevel)': {
        counterIncrement: 'subSection2',
        '&:before': {
          content: 'counter(section)"."counter(subSection)"."counter(subSection2)".\u00A0"',
        },
      },
      '& .numbered.levelUp': {
        counterIncrement: 'subSection',
        counterReset: 'subSection2',
        '&:before': {
          content: 'counter(section)"."counter(subSection)".\u00A0"',
        },
      },
      '& .numbered.topLevel': {
        counterIncrement: 'section',
        counterReset: 'subSection',
        '&:before': {
          content: 'counter(section)".\u00A0"',
        },

      },
      '& .customNumberedItem:first-child': {
        marginTop: theme.spacing(2),
      }
    },
  }),
);

export default useStyles;
